import { UserProfilePage } from 'src/views/userprofile'
import pathMap from 'src/paths/pathMap'

class UserProfileRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.USER_PROFILE_LIST_VIEW,
        component: UserProfilePage
      }
    ]
  }
}

export default UserProfileRoute
